import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "sesizari_map_box_holder" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_map_base = _resolveComponent("map-base")
  const _component_map_filter = _resolveComponent("map-filter")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "col-md-12 px-0 position-relative",
      id: _ctx.controlId
    }, [
      _createElementVNode("div", {
        id: "map_complaints",
        style: _normalizeStyle({'width': '100%', height: _ctx.mapHeight+'px', top:0, 'z-index':'1', position:(_ctx.useGmap?'absolute':'relative')})
      }, null, 4),
      (_ctx.useGmap)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "map_complaints_gmap",
            style: _normalizeStyle({'width': '100%', height: _ctx.mapHeight+'px'})
          }, null, 4))
        : _createCommentVNode("", true),
      _createVNode(_component_map_base, {
        lang: _ctx.lang,
        "map-center": _ctx.mapCenter,
        "map-height": "mapHeight",
        "zoom-level": _ctx.zoomLevel,
        "is-admin": _ctx.isAdmin,
        "custom-street-names": _ctx.customStreetNames,
        extent: _ctx.extent
      }, null, 8, ["lang", "map-center", "zoom-level", "is-admin", "custom-street-names", "extent"])
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_map_filter, {
        lang: _ctx.lang,
        open: true,
        "category-list": _ctx.categoryList,
        "status-list": _ctx.statusList,
        "is-admin": _ctx.isAdmin
      }, {
        add_complaint: _withCtx(() => [
          _renderSlot(_ctx.$slots, "add_complaint")
        ]),
        _: 3
      }, 8, ["lang", "category-list", "status-list", "is-admin"])
    ])
  ]))
}